import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { PlaceholderComponent } from './placeholder.component';

@NgModule({
  declarations: [PlaceholderComponent],
  imports: [CommonModule, MatIconModule],
  exports: [PlaceholderComponent],
})
export class PlaceholderModule {}
